import {LocalStorageService} from 'ngx-webstorage';
import { Input, Component, Output, EventEmitter, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  username: String |""
  @Input() error: string | null;
  form: FormGroup = new FormGroup({
    question1: new FormControl(''),
    question2: new FormControl(''),
  });

  constructor(private storage:LocalStorageService, private router: Router) { }

  ngOnInit() {
    this.username = this.storage.retrieve('username');
  }
  submit(){
    console.log('submit')
    this.router.navigateByUrl('step2')
  }

  q2ChangeEvent(event){
    if (this.form.controls.question2.value == "q2choice1"){
      this.error = null;
    } else{
      this.error = 'simulated an error'
    }
  }
}
